import * as PathName from './PathName'
export const base = '/api/v1'
export const CORE = '/core'

export const BASE_ENDPOINT = process.env.REACT_APP_BASE_ENDPOINT
export const API_ENDPOINT = BASE_ENDPOINT + base + CORE

export const GET_ACCESS_TOKEN = '/Access/access-token'
export const GET_REFRESH_TOKEN = '/Access/refresh-token'
// Common
export const GET_USER_PROFILE = '/getUserProfile'
export const GET_VIEW_MEETING_BY_ID = '/getMeetingById'
export const NEW_MEETING = '/createMeeting'
export const NOTIFICATION = '/notification/{userId}/all'

// RoutingAccess
export const GET_ALL_FEATURES = 'Access/features'
export const FEATURE_NAVIGATION_MENU = 'Access/FeatureNavigationMenu'

// Dashboard
export const GET_RISK_DASHBOARD = '/risk/RiskDashboard'
export const GET_COMP_STAGES = '/Complaince/ComplianceStages'
export const COMPLIANCE_HIERARCHY = '/Complaince/GetComplianceHierarchy'
export const GET_RISK_NON_COMPLIANCES = '/Complaince/riskof_non-compliance'
export const GET_COMPLIANCE_ACTION = '/Complaince/compliance-action'
export const GET_COST_NON_COMPLIANCE_DUE = '/Complaince/costOfNonComplianceDue'
export const GET_COST_NON_COMPLIANCE_OVERDUE = '/Complaince/costOfNonComplianceOverDue'
export const GET_COMPLIANCE_TREND_ANALYSIS = '/Complaince/complianceTrendAnalysis'
export const GET_RACI_COUNT = '/Complaince/racicount'
export const GET_COMPLIANCE_DASHBOARD = '/Complaince/ComplianceDashboard'
export const GET_RISK_BY_ID_CATEGORY = '/risk/{typecategory}'
export const GET_RISK_HEATMAP_BY_ID_CATEGORY = '/risk/{category}'
export const GET_COMPLIANCE_REGULATION_CHART = '/Complaince/complianceRegulationChart'
export const GET_COMPLIANCE_FREQ_REGULATION_CHART = '/Complaince/complianceFrequencyRegulationChart'
export const GET_ONE_TIME_COMPLIANCE = '/Complaince/GetAllOneTimeCompliances'
export const POST_ONE_TIME_COMPLIANCE = '/Complaince/ProcessOneTimeCompliances'
export const GET_DUE_TODAY_COMPLIANCES = '/Complaince/GetDueTodayCompliances'

// OnBoarding
export const CREATE_SURVEY_DATA = '/survey/CreateCompanyProfile'
export const GET_SURVEY_DATA = '/survey/Question{vertexId}/{templateId}'
export const UPDATE_SURVEY_DATA = '/survey/UpdateCompanyProfile'
export const CREATE_BOARD_COMPOSITION = '/organization/CreateBoardComposition'
export const GET_BOARD_COMPOSITION = '/organization/GetBoardComposition'
export const CREATE_ORG_CHART = '/organization/CreateOrganizationChart'
export const EDIT_ORG_CHART_NODE = '/organization/OrganizationChartPostition'
export const GET_ORG_CHART = '/organization/GetOrganizationChart'
export const CREATE_ORG_REGULATION = '/organization/AddOrgRegulation'
export const GET_ORG_REGULATION = '/organization/GetOrgRegulation'
export const GET_USER_DETAILS_BY_ID = '/organization/GetUserDetailsById'
export const GET_ORG_TYPE = '/masterController/GetAllOrganizationType'
export const CREATE_COMPANY_PROFILE = '/survey/OnboardingCompanyProfile'
export const GET_COMPANY_PROFILE = '/survey/GetOrganizationById'
export const GET_COUNTRY = '/masterController/countries'
export const GET_STATE = '/masterController/states'
export const GET_CITY = '/masterController/cities'

// export const CREATE_ON_BOARDINNG = '/organization/Onboarding'

// raci
export const GET_DEP_ORGANIZATION = '/user/GetDepatmentsByOrganization'
export const GET_ROLES_BY_DEP = '/user/GetRolesByDepartment'
export const GET_USER_BY_ROLES = '/user/GetUsersByRole'
export const GET_MANAGEMENT_TEAM = '/user/GetManagementTeam'

// Governance setup
export const GET_ALL_DEPARTMENTS = '/masterController/GetAllDepartments'
export const GET_ALL_USER_DETAILS = '/masterController/GetAllUserDetails'
export const GET_ALL_REGULATIONS = '/masterController/GetAllRegulations'
export const GET_ALL_REGULATIONS_TYPE = '/organization/GetRegulationsBasedOnTypes'
export const GET_SELECTED_REGULATIONS = '/organization/GetSelectedRegulations'
export const SELECT_ORG_REGULATION = 'organization/SelectOrgRegulation'
export const ADD_ORG_REGULATION = '/organization/AddOrgRegulation'

// add compliance
export const CREATE_COMPLIANCE = '/Complaince/CreateComplaince'
export const CREATE_USER_COMPLIANCE = '/Complaince/CreateComplianceResponses'
export const GET_ALL_COMP = '/Complaince/getAllCompliances'
export const GET_COMP_BY_ID = '/Complaince/viewComplianceById'
export const GET_COMP_BY_REG_ID = '/Complaince/SelectComplianceByRegId'
export const GET_SELECTED_COMPLIANCE = '/Complaince/GetSelectedComplianceTemplates'
export const GET_STATUS_TAB_COUNT = '/Complaince/GetStatusTabCount'
export const SUBMIT_SEEDING_COMPLIANCE = '/Complaince/CreateComplianceByTemplate'
export const GET_ALL_COMP_FOR = '/masterController/GetAllComplianceFor'
export const GET_ALL_COMP_CATEGORY = '/masterController/GetAllComplianceCategory'
export const GET_ALL_COMP_SUB_CATEGORY = '/masterController/GetAllComplianceSubCategory'
export const GET_ALL_COMP_FREQUENCY = '/Complaince/getAllComplainceFrequency'
export const GET_ALL_COMP_UOM = '/masterController/GetAllUoM'
export const APPROVE_COMPLIANCE = '/Complaince/ApproveCompliance'
export const UPDATE_MODIFIED_DUE_DATE = '/Complaince/updateModifiedDueDate'
export const GET_MODIFIED_DUE_DATE = '/Complaince/modifyduedate'
export const GET_COMPLIANCE_TIMELINE = '/Complaince/compliance-Timeline'
// meeting screen
export const GET_UPCOMING_EVENTS = BASE_ENDPOINT + base + PathName.GET_UPCOMING_EVENTS
export const GET_MEETING_BY_ID = BASE_ENDPOINT + base + PathName.GET_MEETING_BY_ID
export const CREATE_NEW_MEETING = '/grc/meetingScheduler/Create'

// Risk
export const GET_RISK_DETAILS = '/getRiskDetails'
export const GET_RISKS = '/risk/GetRisks'
// export const GET_RISK_BY_ID = PathName.GET_RISK_BY_ID
export const CREATE_RISK = '/risk/CreateRisk'
export const RISK_HISTORY = '/risk/ViewHistory'
export const RISK_DISPUTE = '/risk/GetDispute'
export const GET_RISK_BY_ID = '/risk/GetRiskById'
export const CREATE_RISK_ANALYZE = '/risk/CreateAnalyze'
export const CREATE_MITIGATION_PLAN = '/risk/CreateMitigationPlan'
export const CREATE_QUANTITATIVE_RISK_ASSESSMENT = '/risk/CreateQuantitativeRiskAssessment'
export const CREATE_QUALITATIVE_RISK_ASSESSMENT = '/risk/CreateQualitativeRiskAssessment'
export const CREATE_TASKS = '/risk/CreateTasks'
export const GET_NON_COMPLIANCE = '/Complaince/NonCompliance'
export const GET_RISK_HISTORY = 'risk/RiskHistoryById'
export const GET_RISK_PERIODICITY = 'risk/RiskPeriodicity'
export const GET_RISK_SEARCH_HISTORY = '/risk/SearchHistory'
// Chat & TimeLine
export const GET_TIMELINE_BY_RISK_ID = '/risk/GetTimelineByRiskId?riskId={riskId}'

// ISSUE
export const CREATE_ISSUE = '/issue/CreateIssue'
export const GET_ISSUE = '/issue/GetIssue'
export const GET_ISSUE_DASHBOARD = '/issue/GetIssueDashboard'
export const GET_ISSUE_BY_ID = '/issue/GetIssueById'
export const CREATE_ISSUE_ANALYZE = '/issue/CreateIssueAnalyzeRequest'
export const CREATE_ISSUE_PLANNING = '/issue/CreateIssuePlanning'
export const CREATE_ISSUE_LESSON_LEARNT = '/issue/CreateIssueLessonLearnt'
export const GET_ISSUE_HISTORY = 'issue/IssueHistoryById'
export const GET_ISSUE_PERIODICITY = 'issue/IssuePeriodicity'
export const GET_ISSUE_SEARCH_HISTORY = '/issue/IssueHistoryFilter'

// Common
export const GET_ALL_ROLE = '/user/GetRolesByOrganization'
export const GET_ORG_LOGO = '/survey/GetOrganizationLogo'
export const GET_HAS_ORGS = '/user/HasMultipleOrgs'
export const GET_VACANCY_GOV = '/organization/VacanyGovernance'
export const GET_ALL_DEPARTMENT_BY_ORGID = '/user/GetDepatmentsByOrganization'
export const GET_ALL_DESIGNATION_BY_ORGID = '/user/GetDesignationByOrganization'
export const GET_ALL_DESIGNATION_BY_DEPT_ID = '/user/GetDesignationByDepartment?departmentId={departmentId}'

// Board Member
export const CREATE_BOARD_MEMBER = '/organization/CreateBoardComposition'
export const GET_ALL_BOARD_MEMBER = '/organization/GetBoardComposition'

// COMPLIANCE_CALENDAR
export const CREATE_COMPLIANCE_CALENDAR = '/Complaince/ComplianceCalenderView'
export const POST_CLOSED_COMPLIANCE_WITH_PENALTY = '/Complaince/ClosedComplianceWithPenalty'
export const POST_CLOSED_COMPLIANCE_WITHOUT_PENALTY = '/Complaince/ClosedComplianceWithoutPenalty'
export const POST_COMPLIANCE_CLOSED_COST_SUMMARY = '/Complaince/ComplianceClosedCostSummary'
export const POST_RISK_HISTORY_DASHBOARD = '/risk/RiskHistoryDashboard'

// login
export const SEND_LOGIN_WITH_OTP = '/user/SendEmailWithOtp?emailId={emailId}'
export const VERIFY_LOGIN_WITH_OTP = '/user/VerifyLoginOtpByOrg?emailId={emailId}&otp={otp}'
// export const VERIFY_LOGIN_WITH_OTP = '/user/VerifyLoginOtp?emailId={emailId}&otp={otp}'
export const GET_ALL_ORGANIZATION_BY_MAIL = '/user/GetAllOrganizationByEmailId?emailId={emailId}'
export const GET_DATA_BY_ORGANIZATION = '/user/GetOrganizationByEmailId?emailId={emailId}&orgId={orgId}'
export const SEND_INVITE_FROM_ONBOARDING = '/user/SendInviteFromOnboarding?orgId={orgId}&emailId={emailId}'
export const CREATE_COMPLIANCE_CALENDAR_OVERDUE = '/Complaince/ComplianceOverDueCount'
export const LOGIN_USER_LOG = '/user/LogUserLogins?orgId={orgId}&emailId={emailId}&userId={userId}&type={type}'

// Settings
export const GET_ALL_USER_LIST = '/user/GetUsersByDesignation?designationId={designationId}&orgId={orgId}&deptId={deptId}'
export const GET_ALL_ROLES_ACCESS = '/Access/GetAllRolePermission'
export const CREATE_ROLES_PERMISSIONS = '/Access/CreateRolePermission'
export const CREATE_ROLES = '/User/CreateRoles'
export const GET_APPLICATION_SETTINGS = '/applicationSettings/GetApplicationSettings'
export const GET_CONFIGURATION_TITLES = '/organization/GetConfigurationTitles'
export const GET_CONFIGURATION_BASED_ORGANIZATION = '/organization/GetConfigurationByOrganization?orgId={orgId}'
export const SET_CONFIGURATION_BASED_ORGANIZATION = '/organization/SetConfiguration?orgId={orgId}&loginId={loginId}'

// export const GET_ALL_ROLES_ACCESS = '/Access/GetAllRoleAccess?isRecursive=true&isDownwardDirection=true&OrgId=0'
export const GET_ALL_ROLES_CHECKBOXS = '/Access/GetAllRolePermission'
export const GET_ROLE_BY_ID = '/user/GetRoleById'

// notification
export const GET_ALL_NOTIFICATION = '/notification/{userId}/all'
export const READ_NOTIFICATION_BY_ID = '/Notification/read'
export const GET_EXISTING_EMAIL_PHONENO = '/user/ExistingDetails'

// Complaince Preview / Transfer Compliance
// /Complaince/CompliancePreview?userId=10&orgId=1&complianceType=1
export const GET_ALL_COMPLIANCE_PREVIEW = '/Complaince/CompliancePreview'
// /user/GetDepartmentByRole?roleId=-3%27
export const GET_ALL_DEPARTMENT_BY_ROLE_ID = '/user/GetDepartmentByRole'
// /user/GetUsersByRole?roleId=-3&orgId=1&deptId=6%27
export const GET_ALL_USER_BY_ROLE_ID = '/user/GetUsersByRole'
// /Complaince/TransferCompliance?orgId=32&loginId=323
export const POST_TRANSFER_COMPLIANCE = '/Complaince/TransferCompliance'
export const POST_TRANSFER_BODY = '/organization/TransferBody'
export const VIEW_TRANSFER_COMPLIANCE_DETAIL = '/Complaince/ViewtransferedcomplianceDetail'
export const ACKNOWLEDGE_TRANSFER_COMPLIANCE_DETAIL = '/Complaince/ApprovetransferedcomplianceDetail'
export const POST_TRANSFER_COMPLIANCE_DETAIL = '/Complaince/transfer_compliance'

// Body Preview
export const GET_ALL_BODY_PREVIEW = '/organization/BodyPreview'


// Audit Log
export const LOG_ACTION = '/auditlog/LogAction'
export const GET_AUDIT_LOGS = '/auditlog/GetAuditLogs'
export const GET_AUDIT_LOGS_COUNT = '/auditlog/GetAuditLogsCount'
